import * as dbConstants from '../dao/dbConstants';
import * as apiConstants from './apiUtilsConstants';
import { callUIAPI } from './apiUtils';
import { handleUserIsUnauthorized } from './utils';

export const searchEntityRecords = async (entityName, searchParams) => {
  console.log('entityApiUtils.searchEntityRecords - entityName:', entityName, ', searchParams:', searchParams);
  return callUIAPI(apiConstants.entityAPIRoutes[entityName] + '/search', searchParams, apiConstants.METHOD_POST, true);
};

export const getLookupList = async (entityName, params = undefined) => {
  try {
    const response = await callUIAPI(apiConstants.entityAPIRoutes[entityName], params, apiConstants.METHOD_GET, true);
    const labelColumn = dbConstants.entityInfo[entityName].labelColumn;
    return response.data.list.map((record) => ({
      value: record.id,
      label: record[labelColumn],
    }));
  } catch (error) {
    return handleUserIsUnauthorized(error, []);
  }
};

export const sortLookupOptionsByLabel = (options) => {
  if (!Array.isArray(options)) return [];
  return [...options].sort((a, b) => String(a?.label ?? '').localeCompare(String(b?.label ?? '')));
};

export const getDefaultObject = async (entityName) => {
  return callUIAPI(apiConstants.entityAPIRoutes[entityName] + '/defaultObject', null, apiConstants.METHOD_GET, true)
    .then(response => {
      console.log('entityApiUtils.getDefaultObject - response:', response);
      return response.data.item;
    })
    .catch(error => {
      return handleUserIsUnauthorized(error, {});
    });
};

export const getRecord = async (entityName, id = 0) => {
  console.log('entityApiUtils.getRecord - entityName:', entityName, ', id:', id);
  return callUIAPI(apiConstants.entityAPIRoutes[entityName] + '/' + id, null, apiConstants.METHOD_GET, true)
    .then(response => {
      console.log('entityApiUtils.getRecord - response:', response);
      return response.data.item;
    })
    .catch(error => {
      return handleUserIsUnauthorized(error, {});
    });
};

export const saveRecord = async (entityName, record) => {
  console.log('entityApiUtils.saveRecord - entityName:', entityName, ', record:', record);
  return callUIAPI(apiConstants.entityAPIRoutes[entityName], record, record['id'] ? apiConstants.METHOD_PUT : apiConstants.METHOD_POST, true)
    .then(response => {
      console.log('entityApiUtils.saveRecord - response:', response);
      window.dispatchEvent(new CustomEvent('entity-saved', { detail: { entityName } }));
      return response.data.item;
    });
};

export const deleteRecord = async (entityName, id) => {
  console.log('entityApiUtils.deleteRecord - entityName:', entityName, ', id:', id);
  return callUIAPI(apiConstants.entityAPIRoutes[entityName] + '/' + id, null, apiConstants.METHOD_DELETE, true)
    .then(response => {
      console.log('entityApiUtils.deleteRecord - response:', response);
      window.dispatchEvent(new CustomEvent('entity-saved', { detail: { entityName } }));
      return response.data.item;
    });
};
